import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { RoleGuard } from './guards/role.guard';
import { DashboardComponent } from './components/dashboard/dashboard';
import { MemberRosterComponent } from './components/member-roster/member-roster';
import { ChapterDuesComponent } from './components/chapter-dues/chapter-dues';
import { ChapterOfficersComponent } from './components/chapter-officers/chapter-officers';
import { MemberChapterDuesComponent } from './components/member-chapter-dues/member-chapter-dues';
import { ThemeConfiguruationComponent } from './components/theme-configuration/theme-configuration';
import { AcsAnnouncementViewerComponent } from './components/shared/acs-announcement-viewer/acs-announcement-viewer';
import { AcsAnnouncementManagementComponent } from './components/shared/acs-announcement-management/acs-announcement-management';
import { AllChaptersComponent } from './components/all-chapters/all-chapters';
import { ChapterDetailsComponent } from './components/chapter-details/chapter-details';
import { AcsDocumentManagerComponent } from './components/shared/acs-document-manager/acs-document-manager';
import { AdminUsersComponent } from './components/admin-users/admin-users';
import { ImpersonationLogsComponent } from './components/impersonation-logs/impersonation-logs';
import { PortalAccessLogsComponent } from './components/portal-access-logs/portal-access-logs';
import { NoAccessComponent } from './components/no-access/no-access.component';

const routes: Routes = [
  { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
  { path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard, RoleGuard] },
  { path: 'members', component: MemberRosterComponent, canActivate: [AuthGuard, RoleGuard] },
  { path: 'chapters', component: AllChaptersComponent, canActivate: [AuthGuard, RoleGuard] },
  { path: 'chapter-details', component: ChapterDetailsComponent, canActivate: [AuthGuard, RoleGuard] },
  { path: 'chapter-dues', component: ChapterDuesComponent, canActivate: [AuthGuard, RoleGuard] },
  { path: 'chapter-officers', component: ChapterOfficersComponent, canActivate: [AuthGuard, RoleGuard] },
  { path: 'member-chapter-dues', component: MemberChapterDuesComponent, canActivate: [AuthGuard, RoleGuard] },
  { path: 'announcements', component: AcsAnnouncementViewerComponent, canActivate: [AuthGuard, RoleGuard] },
  { path: 'announcements/manage', component: AcsAnnouncementManagementComponent, canActivate: [AuthGuard, RoleGuard] },
  { path: 'documents', component: AcsDocumentManagerComponent, canActivate: [AuthGuard, RoleGuard] },
  { path: 'admin/themes', component: ThemeConfiguruationComponent, canActivate: [AuthGuard, RoleGuard] },
  { path: 'admin/users', component: AdminUsersComponent, canActivate: [AuthGuard, RoleGuard] },
  { path: 'admin/impersonation-logs', component: ImpersonationLogsComponent, canActivate: [AuthGuard, RoleGuard] },
  { path: 'admin/portal-logs', component: PortalAccessLogsComponent, canActivate: [AuthGuard, RoleGuard] },
  { path: 'no-access', component: NoAccessComponent },
  { path: '**', redirectTo: '/dashboard' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }